"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverBase = exports.formatQueryWithoutParams = exports.runQueryOnDriver = exports.runCommandOnDriver = void 0;
const compact_1 = __importDefault(require("lodash/compact"));
const isString_1 = __importDefault(require("lodash/isString"));
const SqlDumper_1 = require("./SqlDumper");
const dbgate_query_splitter_1 = require("dbgate-query-splitter");
const dbgate_sqltree_1 = require("dbgate-sqltree");
const detectSqlFilterBehaviour_1 = require("./detectSqlFilterBehaviour");
const getLogger_1 = require("./getLogger");
const stringTools_1 = require("./stringTools");
const logger = (0, getLogger_1.getLogger)('driverBase');
const dialect = {
    limitSelect: true,
    rangeSelect: true,
    topRecords: false,
    offsetFetchRangeSyntax: true,
    stringEscapeChar: "'",
    fallbackDataType: 'nvarchar(max)',
    quoteIdentifier(s) {
        return s;
    },
    columnProperties: {
        isSparse: false,
        isPersisted: false,
    },
    defaultSchemaName: null,
};
function runCommandOnDriver(pool, driver, cmd) {
    return __awaiter(this, void 0, void 0, function* () {
        const dmp = driver.createDumper();
        if ((0, isString_1.default)(cmd)) {
            dmp.put(cmd);
        }
        else {
            cmd(dmp);
        }
        // console.log('CMD:', dmp.s);
        yield driver.query(pool, dmp.s, { discardResult: true });
    });
}
exports.runCommandOnDriver = runCommandOnDriver;
function runQueryOnDriver(pool, driver, cmd) {
    return __awaiter(this, void 0, void 0, function* () {
        const dmp = driver.createDumper();
        if ((0, isString_1.default)(cmd)) {
            dmp.put(cmd);
        }
        else {
            cmd(dmp);
        }
        // console.log('QUERY:', dmp.s);
        return yield driver.query(pool, dmp.s);
    });
}
exports.runQueryOnDriver = runQueryOnDriver;
function formatQueryWithoutParams(driver, sql) {
    const dmp = driver.createDumper();
    dmp.put(sql);
    return dmp.s;
}
exports.formatQueryWithoutParams = formatQueryWithoutParams;
exports.driverBase = {
    analyserClass: null,
    dumperClass: SqlDumper_1.SqlDumper,
    dialect,
    databaseEngineTypes: ['sql'],
    supportedCreateDatabase: true,
    analyseFull(pool, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this, version);
            return analyser.fullAnalysis();
        });
    },
    analyseSingleObject(pool, name, typeField = 'tables') {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this);
            return analyser.singleObjectAnalysis(name, typeField);
        });
    },
    analyseSingleTable(pool, name) {
        return this.analyseSingleObject(pool, name, 'tables');
    },
    analyseIncremental(pool, structure, version) {
        return __awaiter(this, void 0, void 0, function* () {
            const analyser = new this.analyserClass(pool, this, version);
            return analyser.incrementalAnalysis(structure);
        });
    },
    createDumper(options = null) {
        return new this.dumperClass(this, options);
    },
    script(pool, sql, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if ((options === null || options === void 0 ? void 0 : options.useTransaction) && this.supportsTransactions) {
                runCommandOnDriver(pool, this, dmp => dmp.beginTransaction());
            }
            for (const sqlItem of (0, dbgate_query_splitter_1.splitQuery)(sql, this.getQuerySplitterOptions('script'))) {
                try {
                    if (options === null || options === void 0 ? void 0 : options.logScriptItems) {
                        logger.info({ sql: (0, stringTools_1.getLimitedQuery)(sqlItem) }, 'Execute script item');
                    }
                    yield this.query(pool, sqlItem, Object.assign({ discardResult: true }, options === null || options === void 0 ? void 0 : options.queryOptions));
                }
                catch (err) {
                    if ((options === null || options === void 0 ? void 0 : options.useTransaction) && this.supportsTransactions) {
                        runCommandOnDriver(pool, this, dmp => dmp.rollbackTransaction());
                    }
                    throw err;
                }
            }
            if ((options === null || options === void 0 ? void 0 : options.useTransaction) && this.supportsTransactions) {
                runCommandOnDriver(pool, this, dmp => dmp.commitTransaction());
            }
        });
    },
    operation(pool, operation, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { type } = operation;
            switch (type) {
                case 'createSchema':
                    yield runCommandOnDriver(pool, this, dmp => dmp.createSchema(operation.schemaName));
                    break;
                case 'dropSchema':
                    yield runCommandOnDriver(pool, this, dmp => dmp.dropSchema(operation.schemaName));
                    break;
                default:
                    throw new Error(`Operation type ${type} not supported`);
            }
        });
    },
    getNewObjectTemplates() {
        if (this.databaseEngineTypes.includes('sql')) {
            return [{ label: 'New view', sql: 'CREATE VIEW myview\nAS\nSELECT * FROM table1' }];
        }
        return [];
    },
    loadFieldValues(pool, name, columnName, search) {
        return __awaiter(this, void 0, void 0, function* () {
            const dmp = this.createDumper();
            const select = {
                commandType: 'select',
                distinct: true,
                topRecords: 100,
                from: {
                    name,
                },
                columns: [
                    {
                        exprType: 'column',
                        columnName,
                        alias: 'value',
                    },
                ],
                orderBy: [
                    {
                        exprType: 'column',
                        columnName,
                    },
                ],
            };
            if (search) {
                const tokens = (0, compact_1.default)(search.split(' ').map(x => x.trim()));
                if (tokens.length > 0) {
                    // @ts-ignore
                    select.where = {
                        conditionType: 'and',
                        conditions: tokens.map(token => ({
                            conditionType: 'like',
                            left: {
                                exprType: 'column',
                                columnName,
                            },
                            right: {
                                exprType: 'value',
                                value: `%${token}%`,
                            },
                        })),
                    };
                }
            }
            // @ts-ignore
            (0, dbgate_sqltree_1.dumpSqlSelect)(dmp, select);
            const resp = yield this.query(pool, dmp.s);
            return resp.rows;
        });
    },
    readJsonQuery(pool, select, structure) {
        const dmp = this.createDumper();
        (0, dbgate_sqltree_1.dumpSqlSelect)(dmp, select);
        return this.readQuery(pool, dmp.s, structure);
    },
    showConnectionField: (field, values) => false,
    showConnectionTab: field => true,
    getAccessTokenFromAuth: (connection, req) => __awaiter(void 0, void 0, void 0, function* () { return null; }),
    getFilterBehaviour(dataType, standardFilterBehaviours) {
        return (0, detectSqlFilterBehaviour_1.detectSqlFilterBehaviour)(dataType);
    },
    getCollectionExportQueryScript(collection, condition, sort) {
        return null;
    },
    getCollectionExportQueryJson(collection, condition, sort) {
        return null;
    },
    getScriptTemplates(objectTypeField) {
        return [];
    },
    getScriptTemplateContent(scriptTemplate, props) {
        return null;
    },
    dataEditorTypesBehaviour: {
        parseSqlNull: true,
        parseHexAsBuffer: true,
    },
    createSaveChangeSetScript(changeSet, dbinfo, defaultCreator) {
        return defaultCreator(changeSet, dbinfo);
    },
    adaptTableInfo(table) {
        return table;
    },
    listSchemas(pool) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    },
    writeQueryFromStream(dbhan, sql) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    },
};
